import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};

const postHomeFormThreeSlice = createSlice({
  name: "postHomeFormThree",
  initialState,
  reducers: {
    postHomeFormThreeStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postHomeFormThreeSuccess(state, action) {
      state.loading = false;
      console.log(action.payload, "<============action payload");
      state.data = action.payload;
    },

    postHomeFormThreeFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postHomeFormThreeStart,
  postHomeFormThreeSuccess,
  postHomeFormThreeFailure,
  clearError,
  clearMessage,
} = postHomeFormThreeSlice.actions;

export default postHomeFormThreeSlice.reducer;
